import { render, staticRenderFns } from "./CustomRadioButton.vue?vue&type=template&id=3e534183"
import script from "./CustomRadioButton.vue?vue&type=script&lang=js"
export * from "./CustomRadioButton.vue?vue&type=script&lang=js"
import style0 from "./CustomRadioButton.vue?vue&type=style&index=0&id=3e534183&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports